import { css, StarsIcon, styled, Tooltip } from 'canoe';
import React from 'react';

import { Flags, useFlags } from 'commons/hooks';

const Trigger = styled.button<{ isOpen: boolean }>`
  ${({ theme, isOpen }) => css`
    background-color: ${theme.colors.Transparent};
    border-radius: ${theme.borderRadius.small};
    border: none;
    box-shadow: none;
    max-width: 344px;
    padding: 2px;
    display: flex;
    outline: none;
    align-items: center;
    cursor: pointer;
    transition: ${theme.transitions.default()};

    &:active,
    &:focus,
    &:focus-within {
      outline: none;
    }

    &:hover,
    &:focus,
    &:active {
      background-color: ${theme.colors.White};

      svg {
        polygon,
        path {
          stroke: ${theme.colors.OnyxGrayD10};
        }
      }
    }

    ${isOpen &&
    css`
      background-color: ${theme.colors.White};
    `}
  `}
`;

const Badge = styled.p`
  ${({ theme }) => css`
    background-color: ${theme.colors.AquaTealL30};
    border: 1px solid ${theme.colors.AquaTeal};
    border-radius: ${theme.borderRadius.small};
    color: ${theme.colors.AquaTeal};
    font-size: ${theme.fonts.small.fontSize};
    font-weight: ${theme.fontWeights.medium};
    padding: 0 ${theme.spaces.xs};
    margin: 0;
    margin-left: ${theme.spaces.xxs};
    text-align: left;
    flex: 1;
  `}
`;

export const Input = styled.input`
  height: 32px;
  padding: 7px;
  outline: none;
  background: white;
  border: none;
`;

interface Props {
  isOpen: boolean;
  toggleOpen: VoidFunction;
}

export const AskAIButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ isOpen, toggleOpen }: Props, triggerRef) => {
    const {
      [Flags.FIRST_MATE]: withFirstMate,
      [Flags.FIRST_MATE_MODIFY_TEXT]: withModifyText,
    } = useFlags();

    if (!withFirstMate || !withModifyText) {
      return null;
    }

    return (
      <Tooltip placement="top" offset="xxs" content="Get help from Candu AI">
        <Trigger isOpen={isOpen} onClick={toggleOpen} ref={triggerRef}>
          <StarsIcon color={isOpen ? 'OnyxGrayD10' : 'White'} size="s" />
          <Badge>AI Beta</Badge>
        </Trigger>
      </Tooltip>
    );
  },
);
